/**
 * Portfolio component
 *
 * Highlights some of  your creations. These can be designs, websites,
 * open source contributions, articles you've written and more.
 *
 * This is a great area for you to to continually add to and refine
 * as you continue to learn and create.
 */

import React from "react";

/**
 * Desk image
 *
 * Below is a sample desk image. Feel free to update this to an image of your choice,
 * updating below imageAltText to string that represents what you see in that image.
 *
 * Need an image? Check out https://unsplash.com to download a photo you
 * freely use on your site.
 */
import image from "../images/design-desk.jpeg";

const imageAltText = "Desktop with Books and Laptop";

/**
 * Project list
 *
 * An array of objects that will be used to display for your project
 * links section. Below is a sample, update to reflect links you'd like to highlight.
 */
const projectList = [
  {
    title: "FOOD - HUB",
    description:
      "Developed a Dynamic food application using ReactJS, featuring a curated restaurant listing and interactive pages for detailed Menus.",
    url: "https://github.com/AagamAJ/Food-Hub",
  },
  {
    title: "NEWS WEB-PAGE",
    description:
      "Implemented a user-friendly interface that fetches and loads current news from various sources utilizing API endpoints.",
    url: "https://github.com/AagamAJ/Dynamic-News-WebPage",
  },
  {
    title: "MY RESUME SITE",
    description:
      "Created using technologies such as HTML and CSS, and deployed to GitHub pages. Includes my Expertise and Problem Solving Abilities.",
    url: "https://aagam-resume.netlify.app/",
  },
  {
    title: "MY - PORTFOLIO",
    description:
      "I've crafted my portfolio website using React.js and JSX, blending my coding prowess with design expertise, in a visually appealing and interactive manner.",
    url: "https://aagamjain-portfolio.netlify.app/",
  },
];

const Portfolio = () => {
  return (
    <section className="padding" id="portfolio">
      <h2 className="portfolio-head">Portfolio</h2>
      <div className="portfolio-big-container">
        <div className="portfolio-image">
          <img
            src={image}
            alt={imageAltText}
          />
        </div>
        <div className="container">
          {projectList.map((project) => (
            <div className="box" key={project.title}>
              <a href={project.url} target="_blank" rel="noopener noreferrer">
                <h3 className="project-title">{project.title}</h3>
              </a>
              <p className="small">{project.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
